import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { WebsiteService } from 'src/app/_services/website.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-grammar-checker-features',
  templateUrl: './grammar-checker-features.component.html',
  styleUrls: ['./grammar-checker-features.component.scss']
})
export class GrammarCheckerFeaturesComponent implements OnInit {
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;

  constructor(private titleService: Title,
    private toastr: ToastrService,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    private router: Router,
    public loadScript: LoadScriptService
  ) { 
  }
  
  ngOnInit() {
    this.titleService.setTitle("高精度の文法チェッカー | AI英文校正ツールTrinka");
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaは、文章のトーン、文構造、適切な単語やフレーズ、読みやすさを洗練するAIを搭載した文法チェックツール。英語・ドイツ語・スペイン語に対応。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "高精度の文法チェッカー | AI英文校正ツールTrinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaは、文章のトーン、文構造、適切な単語やフレーズ、読みやすさを洗練するAIを搭載した文法チェックツール。英語・ドイツ語・スペイン語に対応。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '高精度の文法チェッカー | AI英文校正ツールTrinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaは、文章のトーン、文構造、適切な単語やフレーズ、読みやすさを洗練するAIを搭載した文法チェックツール。英語・ドイツ語・スペイン語に対応。" });  
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/jp/features/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/grammar-checker' });
    if (isPlatformBrowser(this.platformId)) {
      this.country = localStorage.getItem("country")? localStorage.getItem("country"):"en";
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      //$.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
    }
  }

  

}
